<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-04-29 13:45:48
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\BlockLeave\BlockLeaveMapping\components\groupMapping.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-29 14:56:21
-->
<template>
  <normalDialog
    :title="
      isedit
        ? $t('label_essweb_BlockLeaveMapping_form_property_dialog_editTitle')
        : $t('label_essweb_BlockLeaveMapping_form_property_dialog_newTitle')
    "
    :dialog="show"
    @close="show = false"
    maxWidth="680"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start" class="white lighten-5">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              label="label_essweb_BlockLeaveMapping_list_staffLabel"
              v-model="staff_uuid"
              :disabled="isedit"
              :readonly="isedit"
              chips
              avatar
              :filter="$staffFilter"
              small-chips
              two-line
              :rules="$GetRules(['_Require_Rules'], [null])"
              :items="allStaff"
              item-value="staff_id"
              item-text="preferred_name"
            >
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  size="36"
                  left
                  small
                  contentClass="white--text"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
              <template v-slot:item.avatar="{ data }">
                <StaffAvatar
                  size="36"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:item.title="{ data }">
                <span class="text-body-2">
                  {{ $getCommonLangValue(data.item.preferred_name) }}
                </span>
                <span class="text--secondary text-caption-xs">{{
                  data.item.staff_code
                }}</span>
              </template>

              <template v-slot:item.subtitle="{ data }">
                {{ $getCommonLangValue(data.item.job_post_name) }}
              </template>
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              label="label_essweb_BlockLeaveMapping_form_YearLabel"
              v-model="year"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :items="Years"
              itemValue="value"
              itemText="label"
            ></AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              label="label_essweb_BlockLeavePolicy_list_title"
              v-model="group_uuid"
              :items="allGroup"
              :rules="$GetRules(['_Require_Rules'], [null])"
              itemValue="uuid"
              itemText="block_leave_group_name"
            ></AutoComplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="show = false" />
    </template>
  </normalDialog>
</template>
<script>
export default {
  name: "groupMapping",
  data() {
    return {
      isedit: false,
      show: false,
      allStaff: [],
      allGroup: [],
      year: "",
      uuid: "",
      staff_uuid: "",
      group_uuid: "",
    };
  },
  computed: {
    Years() {
      let arr = [];
      for (let index = 0; index < 100; index++) {
        arr.push({
          value: 2000 + index,
          label: String(2000 + index),
        });
      }
      return arr;
    },
  },
  created() {
    this.$getStaffList().then((res) => {
      this.allStaff = res;
    });
    this.getGroup();
  },
  methods: {
    getGroup() {
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group",
        url: "/block-leave-group/get-list/",
        data: {},
      }).then((res) => {
        this.allGroup = res.data;
      });
    },
    edit(staff_uuid, year, group_uuid, uuid) {
      this.isedit = true;
      this.staff_uuid = staff_uuid;
      this.group_uuid = group_uuid;
      this.year = year;
      this.uuid = uuid;
      this.show = true;
    },
    new() {
      this.isedit = false;
      this.staff_uuid = "";
      this.group_uuid = "";
      this.year = "";
      this.uuid = "";
      this.show = true;
    },
    toSave() {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_user_map_year",
        url: this.uuid
          ? "/block-leave-group-mapping/update/"
          : "/block-leave-group-mapping/add/",
        data: Object.assign(
          {
            staff_uuid: this.staff_uuid,
            year: this.year,
            block_leave_group_uuid: this.group_uuid,
            remarks: "",
          },
          this.uuid ? { uuid: this.uuid } : {}
        ),
      }).then((res) => {
        this.$emit("change", this.staff_uuid);
        this.show = false;
      });
    },
  },
};
</script>